// import React from 'react';
// import { Link } from 'react-router-dom';
// import './searchResults.css'

// const SearchResults = ({ results }) => {
//   const getItemPath = (result) => {
//     switch (result.type) {
//       case 'project':
//         return `/work/${result.slug || result.id}`;
//       case 'news':
//         return `/article/${result.id || result.slug}`;
//       case 'team':
//         return `/team/${result.id || result.slug}`;
//       default:
//         return `/${result.type}s/${result.slug || result.id}`;
//     }
//   };

//   if (!results.length) {
//     return <div className="p-4 text-center">No results found</div>;
//   }

//   return (
//     <div className="search-results divide-y">
//       {results.map((result) => (
//         <div key={`${result.type}-${result.id}`} className="p-4 hover:bg-gray-50">
//           <Link 
//             to={getItemPath(result)}
//             className="block"
//           >
//             <div className="flex items-start">
//               {(result.coverImage || result.featureImage) && (
//                 <img 
//                   src={result.coverImage || result.featureImage} 
//                   alt="" 
//                   className="w-16 h-16 object-cover mr-4"
//                 />
//               )}
//               <div className="flex-1">
//                 <h3 
//                   className="text-lg font-semibold mb-2"
//                   dangerouslySetInnerHTML={{ __html: result.title }}
//                 />
//                 {/* {result.subtitle && (
//                   <p 
//                     className="text-sm text-gray-700 mb-1"
//                     dangerouslySetInnerHTML={{ __html: result.subtitle }}
//                   />
//                 )} */}
//                 {result.description && (
//                   <p 
//                     className="text-gray-600 mb-2 text-sm line-clamp-2"
//                     dangerouslySetInnerHTML={{ __html: result.description }}
//                   />
//                 )}
//                 <div className="text-sm text-gray-500 flex flex-wrap gap-2">
//                   <span className="capitalize">{result.type}</span>
//                   {result.category && ` • ${result.category}`}
//                   {result.location && ` • ${result.location}`}
//                   {result.createdAt && ` • ${new Date(result.createdAt.seconds * 1000).toLocaleDateString()}`}
//                 </div>
//               </div>
//             </div>
//           </Link>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default SearchResults;





// SearchResults.jsx
import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './searchResults.css';

const SearchResults = ({ results, onClickOutside }) => {
  const searchResultsRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchResultsRef.current && 
        !searchResultsRef.current.contains(event.target) &&
        !event.target.closest('input')
      ) {
        onClickOutside?.();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClickOutside]);

  const getItemPath = (result) => {
    switch (result.type) {
      case 'project':
        return `/work/${result.slug || result.id}`;
      case 'news':
        return `/article/${result.id || result.slug}`;
      case 'team':
        return `/team/${result.id || result.slug}`;
      default:
        return `/${result.type}s/${result.slug || result.id}`;
    }
  };

  if (!results.length) {
    return <div className="p-4 text-center">No results found</div>;
  }

  return (
    <div className="search-results divide-y" ref={searchResultsRef}>
      {results.map((result) => (
        <div key={`${result.type}-${result.id}`} className="p-4 hover:bg-gray-50">
          <Link to={getItemPath(result)} className="block">
            <div className="flex items-start">
              {(result.coverImage || result.featureImage) && (
                <img
                  src={result.coverImage || result.featureImage}
                  alt=""
                  className="w-16 h-16 object-cover mr-4"
                />
              )}
              <div className="flex-1">
                <h3
                  className="text-lg font-semibold mb-2"
                  dangerouslySetInnerHTML={{ __html: result.title }}
                />
                {result.description && (
                  <p
                    className="text-gray-600 mb-2 text-sm line-clamp-2"
                    dangerouslySetInnerHTML={{ __html: result.description }}
                  />
                )}
                <div className="text-sm text-gray-500 flex flex-wrap gap-2">
                  <span className="capitalize">{result.type}</span>
                  {result.category && ` • ${result.category}`}
                  {result.location && ` • ${result.location}`}
                  {result.createdAt && ` • ${new Date(result.createdAt.seconds * 1000).toLocaleDateString()}`}
                </div>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default SearchResults;